/* eslint-disable sonarjs/cognitive-complexity */
import {
  BaSeButton,
  BaSeCheckbox,
  BaSeInput,
  BaSeParagraph,
  BaSeTheme,
  useDebounce,
} from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import React from 'react';
import { useInterviewController } from '../../../../hooks/controllers/interview-controller';
import { useModule } from '../../../../hooks/module/module';
import { FilterBottom, FilterContent, FilterHeader } from './data-table-styled';

const cache = Sebrae.StorageUtil.inTemporaryStore();
const cacheKeySebrae = '@empretec:sebrae';

export const ColumnRuralFilter = ({
  setFilter,
  setTags,
  closeFilter,
  columnId,
}) => {
  const {
    getFiltersByType,
    getStatusCompletingInterview,
    getStatusInterview,
    getStatusEmail,
    getFilterValues,
  } = useInterviewController();
  const [originalArray, setOriginalArray] = React.useState([]);
  const [columnFilter, setColumnFilter] = React.useState([]);
  const [showAllCities, setShowAllCities] = React.useState(false);
  const [inputValue, setInputValue] = React.useState('');
  const term = useDebounce(inputValue, 350);

  const { moduleSelected } = useModule();

  const [statusInterview, setStatusInterview] = React.useState([]);
  const [statusCompletingInterview, setStatusCompletingInterview] =
    React.useState([]);

  const handleChange = React.useCallback(
    (option) => (checked) => {
      const [completingStatus, status] = option.split('-');

      if (checked) {
        setStatusInterview((prev) => {
          const newPrev = prev;
          newPrev.push(status);
          return prev;
        });

        setStatusCompletingInterview((prev) => {
          const newPrev = prev;
          newPrev.push(completingStatus);
          return prev;
        });
      } else {
        setStatusInterview((prev) => {
          const newPrev = prev;
          const index = newPrev.indexOf(status);
          if (index !== -1) {
            newPrev.splice(index, 1);
          }

          return newPrev;
        });

        setStatusCompletingInterview((prev) => {
          const newPrev = prev;

          const index = newPrev.indexOf(completingStatus);

          if (index !== -1) {
            // Remove de ambos os arrays na mesma posição
            newPrev.splice(index, 1);
          }

          return newPrev;
        });
      }
      setColumnFilter((actualFilter) => {
        return [
          { statusInterview, statusCompletingInterview },
          ...actualFilter.filter((item) => item !== option),
          ...(checked ? [option] : []),
        ];
      });
    },
    [statusCompletingInterview, statusInterview],
  );

  const getLabel = React.useCallback(
    (option, columnId) => {
      const labelMapper = {
        statusCompletingInterview: getStatusCompletingInterview({
          statusCompletingInterview: option,
        }),
        statusInterview: getStatusInterview({ statusInterview: option }),
        emails: getStatusEmail(option),
      };
      return labelMapper[columnId] ?? option;
    },
    [getStatusCompletingInterview, getStatusEmail, getStatusInterview],
  );

  const buildLabel = React.useCallback(() => {
    const columnFilterNames = columnFilter
      .filter((item) => typeof item === 'string')
      .map((item) => getLabel(item, columnId));
    const columFilterNameFotmated = columnFilterNames.map(
      (item) => mapTag[item],
    );
    //return `${TagLabel[columnId]}${columFilterNameFotmated
    //.join(', ')
    //.replace(/, ([^,]*)$/, ` e $1`)}`;

    return `${TagLabel[columnId]}${columFilterNameFotmated.join(', ')}`;
  }, [columnFilter, columnId, getLabel]);

  const buildTag = React.useCallback(
    (tags) => {
      return [
        ...tags,
        {
          label: buildLabel(),
          onClose: () => {
            setTags((actualTags) => {
              const newTags = [
                ...actualTags.filter(
                  (item) => !item.label.startsWith(TagLabel[columnId]),
                ),
              ];
              const newFilter = Object.fromEntries(
                newTags.map((tag) => {
                  const key = tag.label.split(': ')[0];
                  const items = getLabel(tag.label, key)
                    .split(': ')[1]
                    .split(/(, | e )/g)
                    .filter((f) => f !== ' e ');

                  return [[TagReverseLabel[key]], getFilterValues(items, key)];
                }),
              );

              const filter = {
                fieldOfResearch: '',
                ufs: '',
                cities: '',
                emails: '',
                statusInterview: '',
                statusCompletingInterview: '',
                filterCityName: '',
                ...newFilter,
              };
              setFilter(filter);
              return newTags;
            });
          },
        },
      ];
    },
    [buildLabel, columnId, getFilterValues, getLabel, setFilter, setTags],
  );

  const saveSelection = React.useCallback(() => {
    setFilter((actualFilter) => ({
      ...actualFilter,
      statusCompletingInterviews: [...new Set(statusCompletingInterview)],
      statusInterviews: [...new Set(statusInterview)],
    }));
    setTags((tags) => {
      tags = tags.filter((item) => !item.label.startsWith(TagLabel[columnId]));
      return columnFilter.length > 0 ? buildTag(tags) : [];
    });
    return closeFilter(closeFilter);
  }, [
    buildTag,
    closeFilter,
    columnFilter.length,
    columnId,
    setFilter,
    setTags,
    statusCompletingInterview,
    statusInterview,
  ]);

  const isCityColumn = React.useMemo(() => columnId === 'cities', [columnId]);

  React.useEffect(() => {
    let filtersApplied = {};
    setFilter((actualFilter) => {
      filtersApplied = { ...actualFilter };
      if (
        cache.getItem(cacheKeySebrae) !== 'NA' &&
        !filtersApplied?.fieldOfResearch
      ) {
        filtersApplied = {
          ...filtersApplied,
          ufs: [cache.getItem(cacheKeySebrae)],
        };
      }
      return actualFilter;
    });

    getFiltersByType(moduleSelected?.id, {
      filterType: filterTypeMapper[columnId],
      filterCityName: term,
      isAllCities: showAllCities,
      ...filtersApplied,
    })
      .then((result) => {
        setOriginalArray(result);
      })
      .catch((error) => console.log(error));
  }, [
    columnId,
    getFiltersByType,
    moduleSelected,
    setFilter,
    showAllCities,
    term,
  ]);

  return (
    <>
      {isCityColumn && (
        <FilterHeader>
          <BaSeInput
            inputMode="search"
            value={inputValue}
            onChange={(value) => setInputValue(value)}
            iconButton={{
              typeButton: 'base-icon',
              name: 'search',
              color: BaSeTheme.colors.institucionais.cinzaSebrae60,
            }}
            placeholder="Pesquisar…"
            size="small"
            width="100%"
          />
        </FilterHeader>
      )}
      <FilterContent>
        {originalArray?.map((item, index) => (
          <div>
            {!item.showStatus &&
              item.results &&
              item.results.map((result, idx) => (
                <Option
                  key={idx}
                  option={`${item.status}-${result}`}
                  filter={columnFilter}
                  label={filterRuralTypeMapper[result]}
                  handleChange={handleChange}
                />
              ))}
            {item.showStatus && !item.results && (
              <Option
                key={index}
                option={item.status}
                filter={columnFilter}
                label={filterRuralTypeMapper[item.status]}
                handleChange={handleChange}
              />
            )}
            {item.showStatus && item?.results?.length > 0 && (
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', marginBottom: 8 }}>
                  <BaSeParagraph color={'#394d60'}>
                    {filterRuralTypeMapper[item.status]}
                  </BaSeParagraph>
                </div>
                {item?.results?.map((r, ix) => (
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      marginLeft: 8,
                    }}
                  >
                    <Option
                      key={`${item.status}-${ix}`}
                      option={`${item.status}-${r}`}
                      filter={columnFilter}
                      // label={getLabel(r, columnId)}
                      label={filterRuralTypeMapper[r]}
                      handleChange={handleChange}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
        {isCityColumn && !showAllCities && !term && (
          <BaSeButton
            value="mostrar mais..."
            type="tertiary"
            onClick={() => setShowAllCities(true)}
          />
        )}
      </FilterContent>
      <FilterBottom>
        <BaSeButton
          value="Salvar seleção"
          onClick={saveSelection}
          color={BaSeTheme.colors.institucionais.cinzaSebrae10}
        />
      </FilterBottom>
    </>
  );
};

const Option = ({ option, filter, label, handleChange }) => {
  return (
    <BaSeCheckbox
      color={BaSeTheme.colors.institucionais.cinzaSebrae10}
      label={label}
      checked={filter.includes(option)}
      onChange={handleChange(option)}
    />
  );
};

const filterRuralTypeMapper = {
  AGUARDANDO_AVALIACAO: 'Aguardando avaliação',
  FINALIZADA: 'Finalizado',
  APTO: 'Apto',
  NAO_APTO: 'Não apto',
  EXPIRADA: 'Expirado',
  CERTIFICADA: 'Certificada',
  DESISTENTE: 'Desistente',
};

const mapTag = {
  'FINALIZADA-AGUARDANDO_AVALIACAO': 'Aguardando avaliação',
  'FINALIZADA-APTO': 'Finalizado e Apto',
  'FINALIZADA-NAO_APTO': 'Finalizado e Não apto',
  'EXPIRADA-APTO': 'Expirado e Apto',
  'EXPIRADA-NAO_APTO': 'Expirado e Não apto',
  CERTIFICADA: 'Certificada',
  DESISTENTE: 'Desistente',
};

const filterTypeMapper = {
  ufs: 'UF',
  cities: 'CITY',
  emails: 'STATUS_EMAIL',
  statusCompletingInterviews: 'STATUS_INTERVIEW',
  situationInterview: 'STATUS_COMBINATIONS',
  statusInterviews: 'STATUS_RESULT',
};

const TagLabel = {
  ufs: 'UF: ',
  cities: 'Cidade: ',
  emails: 'E-mail: ',
  statusCompletingInterviews: 'Status: ',
  statusInterviews: 'Resultado: ',
  situationInterview: 'Situação: ',
};

const TagReverseLabel = {
  UF: 'ufs',
  Cidade: 'cities',
  Email: 'emails',
  Status: 'statusCompletingInterviews',
  Resultado: 'statusInterviews',
};
